/* src/components/landing/LpFooter.jsx */
import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_COLS } from '../../data/landing';

const LEGAL = [
  { label: 'Termos de uso', to: '/termos' },
  { label: 'Privacidade',   to: '/privacidade' },
  { label: 'LGPD',          to: '/lgpd' },
];

export default function LpFooter() {
  return (
    <footer style={{ padding: '60px 0 32px', borderTop: '1px solid var(--border)' }}>
      <div className="container">

        <div className="footer-grid g4" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 48, marginBottom: 48 }}>
          {/* Brand */}
          <div>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', fontWeight: 700, fontSize: '1.3rem', color: 'var(--primary)' }}>
              <div style={{ width: 36, height: 36, background: 'var(--primary)', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent)', fontWeight: 700, fontSize: '1.1rem' }}>S</div>
              SimulaBank
            </Link>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginTop: 12, maxWidth: 280, lineHeight: 1.6 }}>
              A ferramenta definitiva para simulação e comparação de financiamento imobiliário entre múltiplos bancos.
            </p>
          </div>

          {/* Cols */}
          {FOOTER_COLS.map(col => (
            <div key={col.title}>
              <h4 style={{ fontSize: '0.8rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--text-muted)', marginBottom: 16 }}>{col.title}</h4>
              {col.links.map(({ label, to }) => (
                <Link key={label} to={to} style={{ display: 'block', color: 'var(--text)', textDecoration: 'none', fontSize: '0.9rem', padding: '4px 0' }}>{label}</Link>
              ))}
            </div>
          ))}
        </div>

        <div className="footer-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 24, borderTop: '1px solid var(--border)', fontSize: '0.82rem', color: 'var(--text-muted)' }}>
          <span>© 2026 SimulaBank. Todos os direitos reservados.</span>
          <div style={{ display: 'flex', gap: 24 }}>
            {LEGAL.map(({ label, to }) => (
              <Link key={label} to={to} style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>{label}</Link>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
}
